import userApi from '@/api/user';

export default {
  async getTeachers({commit, state}, payload) {
    let params = {
      name: state.filter.name,
      gender: state.filter.gender,
      subjectId: state.filter.subject,
      schoolSystemId: state.filter.schoolSystem
    };
    let res = await userApi.getTeachers(params);
    if (!res.success) {
      throw new Error('無法取得老師列表');
    }
    commit('updateTeachers', res.teachers);
  }
};
